module.exports = __webpack_public_path__ + "img/vn_vn.ce642976.png";